export const getTypeAheadItemId = (listId: string, itemIndex: number): string =>
	`${listId}--${itemIndex}`;
